import { useState } from "react";
import { useForm, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  ButtonGroup,
  DialogBody,
  DialogFooter,
  DialogRoot,
  DropsButton,
  DropsDialogContent,
  Text,
} from "shared/components/Spor";
import { useThemeSemantic } from "shared/theme/themeSemantic";

export const useConfirmClose = (onClose: () => void) => {
  const { t } = useTranslation();
  const semantics = "warning";
  const theme = useThemeSemantic(semantics);
  const [showConfirmCloseAlert, setShowConfirmCloseAlert] = useState(false);

  const defaultForm = useForm();

  const {
    formState: { isDirty },
  } = useFormContext() ?? defaultForm;
  const hasUnsavedChanges = isDirty;

  const defaultClose = { onClose, ConfirmCloseAlert: () => null };
  if (!hasUnsavedChanges) return defaultClose;

  return {
    onClose: () => setShowConfirmCloseAlert(true),
    ConfirmCloseAlert: () =>
      showConfirmCloseAlert && (
        <DialogRoot
          open
          onOpenChange={() => {}} // Empty in order to disallow clicking outside
          size="xs"
          placement="center"
        >
          <DropsDialogContent
            semantics={semantics}
            borderRadius="18px"
            boxShadow={theme.boxShadow}
          >
            <DialogBody
              mt="6px"
              p="24px"
              borderRadius="12px"
              display="flex"
              flexDirection="column"
              gap="3px"
            >
              <Text fontWeight="600">{t("Vil du forkaste endringene?")}</Text>
              <Text variant="xs" color={theme.colorSemanticTextSecondary}>
                {t(
                  "Alle dine endringer vil gå tapt. Det er ikke mulig å angre dette valget.",
                )}
              </Text>
            </DialogBody>
            <DialogFooter p="24px" pt="12px" pb="18px">
              <ButtonGroup justifyContent="space-between" w="100%">
                <DropsButton
                  type="button"
                  variant="tertiary"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowConfirmCloseAlert(false);
                  }}
                >
                  {t("Nei, behold")}
                </DropsButton>
                <DropsButton
                  variant="primary"
                  semantics={semantics}
                  onClick={(e) => {
                    e.preventDefault();
                    onClose();
                  }}
                  type="submit"
                >
                  {t("Ja, forkast")}
                </DropsButton>
              </ButtonGroup>
            </DialogFooter>
          </DropsDialogContent>
        </DialogRoot>
      ),
  };
};
